module.exports = __webpack_public_path__ + "static/reigas_imgs_1_cocinas-ea4586b10ce7186f7d8aa6e907d27bac.png";